export const RQ_GET_DOCTOR_VISIT_REPORT_API = {
  url:'reports/web/effort/doctorvisit/<%= locationId %>/<%= fromYearMonthDate %>/<%= toYearMonthDate %>?entityTagId=<%= entityTagId %>',
  method: 'GET',
  auth: true,
  search: true,
};

export const RQ_GET_NEW_DOCTOR_VISIT_REPORT_API = {
  url:'reports/web/effort/newDoctorvisit/<%= locationId %>/<%= fromYearMonthDate %>/<%= toYearMonthDate %>?entityTagId=<%= entityTagId %>',
  method: 'GET',
  auth: true,
};
